// extracted by mini-css-extract-plugin
export default {"register_now":"RegisterNow_register_now__6rcF2"};